import React from 'react';
import PieChart from './pie-chart';

const sortValues = (values) => {
  values.sort((a, b) => a[0] - b[0]);
  return values;
};

const RiskModel = (props) => (
  <PieChart
    {...props}
    sortValues={sortValues}
    chartVariantClassName="pie-chart risk-model"
  />
);

export default RiskModel;
